import angular from 'angular';

document.write(require('./view.html').default);

angular.module("merchant.application.page.logout", [
]).controller("merchant.application.page.logout.controller", [
    "$scope", "$controller", "$location", "$window",
    "merchant.application.main.factory.authentication",
    "merchant.application.main.factory.okta",
    "core.application.main.factory.country",
    function($scope, $controller, $location, $window, Authentication, Okta, Country) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        $scope.model.sso = {
            enabled: false,
        }

        Okta.isFeatureEnabled().then(function (value) {
            $scope.model.sso.enabled = value;
        });

        Authentication.logout(function() {
            if(Authentication.ssoUser() && $scope.model.sso.enabled){
                const countryCode = Country.getCountryCodeFromUrl();
                const redirectUrl = $window.location.origin + '/' + countryCode.toLowerCase() + '/merchant/login'
                Authentication.oktaLogout(redirectUrl);
            } else {
                $location.path("login");
            }
        });
    }
]);
